import React, { forwardRef, ForwardRefRenderFunction } from "react";
// import { useController } from "react-hook-form";
import { TextInput as TextInputRN } from "react-native";
import { TextInput, TextInputProps, HelperText } from "react-native-paper";
import { themes } from "../../design/colors";
interface TextFieldProps extends TextInputProps {
  mode?: "outlined" | "flat";
  label?: any;
  placeholder?: string;
  secureTextEntry?: boolean;
  value: string;
  onChangeText: any;
}

/**
 * Componente: TextField
 * - `name`: props para identificação pro backend
 * - `control`: props para o react hook form
 * - `supportingText`: props para o texto de suporte do input
 * - `hasSupportingText`: props para exibir o texto de suporte do input
 * - `mask`: props que define o tipo de máscara
 * **/
const TextFieldComponent: ForwardRefRenderFunction<
  TextInputRN,
  TextFieldProps
> = (
  { mode = "outlined", label, placeholder, secureTextEntry, value, onChangeText, ...rest }: TextFieldProps,
  ref
) => {
  return (
    <>
      <TextInput
        {...rest}
        mode="outlined"
        label={label}
        placeholder={placeholder}
        secureTextEntry={secureTextEntry}
        value={value}
        onChangeText={(text) => onChangeText(text)}
        style={{ marginBottom: 19 }}
        theme={{
          colors: {
            text: themes.colors.white,
            background: themes.colors.gray2,
            primary: themes.colors.white,
            disabled: themes.colors.disabled,
            placeholder: themes.colors.white,
            error: themes.colors.red1,
            onSurfaceVariant: themes.colors.white,
            onSurface: themes.colors.white,
            onError: themes.colors.red1,
          },
          roundness: 8,
        }}
      />
    </>
  );
};

export const TextFieldLogin = forwardRef(TextFieldComponent);
